module.exports = __webpack_public_path__ + "static/media/image-card-2.68e1c3a4.png";